import { useEffect, useRef } from 'react';
import { useField } from '@unform/core';
import { ConteinerInput, Borda, Conteiner, InputField, Texto, TextoDeErro } from './styles';

function TextArea({ nome, titulo, desabilitado = false, placeholder }) {
  const inputRef = useRef(null);
  const { fieldName, registerField, defaultValue, error } = useField(nome);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      path: 'value',
    });
  }, [fieldName, registerField]);

  return (
    <>
      <Conteiner>
        {titulo ? <Texto>{titulo}</Texto> : null}
        <ConteinerInput>
          <InputField
            ref={inputRef}
            defaultValue={defaultValue}
            disabled={desabilitado}
            placeholder={placeholder}
          />
          <Borda error={error} />
        </ConteinerInput>
      </Conteiner>
      {error && <TextoDeErro>{error}</TextoDeErro>}
    </>
  );
}

export default TextArea;
